module.exports = __webpack_public_path__ + "e04a652149d03008256aa278b01f0eb2.pdf";